import gql from 'graphql-tag';

const QUERY_AREAS = gql`
  query Areas($city: String!) {
    areas(city: $city) {
      id
      name
    }
  }
`;

export const getAreasQuery = client => city =>
  client.query({
    query: QUERY_AREAS,
    fetchPolicy: 'network-only',
    variables: {
      city
    }
  });

const QUERY_AREA_INFO = gql`
  query AreaInfo($city: String!, $slug: String!) {
    areaInfo(city: $city, slug: $slug) {
      id
      name
      slug
    }
  }
`;

export const getAreaInfoQuery = client => (city, slug) =>
  client.query({
    query: QUERY_AREA_INFO,
    fetchPolicy: 'network-only',
    variables: {
      city,
      slug
    }
  });

export default { getAreasQuery, getAreaInfoQuery };
